import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=bc054644&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=bc054644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc054644",
  null
  
)

export default component.exports